import axios from "axios";
const jsonConfig = require("../../Config.json");

const getRecruiterPrivateTestAccessResponse = async (payload) => {

  try {
    const response = await axios.post(
      jsonConfig.apiUrl + "RecruiterPrivateTestAccesses",payload,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );

    return response;

  } catch (error) {
    console.log("Error Fetch Recruiter Private Access", error);
    return Promise.reject(error);
  }
};

export default getRecruiterPrivateTestAccessResponse;